import React, { useEffect } from 'react';
import Layout from '../layouts/Layout';
import { PUBLIC_URL } from '../utils/const';
import { BlogPage } from 'reactyll';
import MarkDown from 'react-markdown'
import rehypeRaw from 'rehype-raw';
import { Head } from 'vite-react-ssg';
import { useFathom } from '../contexts/FathomContext';
import { Container, Title, Text, Image, Box, Paper, Anchor, Group, Button, Stack, Divider } from '@mantine/core';
import { redirectWithParameters } from '../utils/common';
import { getBlogByLanguage } from '../utils/blog';
import { blogs } from '../_blog/routes';
import { useTranslation } from 'react-i18next';

export interface ExtraProperties {
    date: string
    headline: string
    description: string
    publishDate: string
    readMore?: string[]
}

const content: BlogPage<ExtraProperties> = JSON.parse(decodeURIComponent(atob(`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`)));


const InnerBlogTemplate: React.FC = () => {
    const { trackEvent } = useFathom();
    const { i18n } = useTranslation();

    const matchingLanguageCode = content.properties.language || i18n.resolvedLanguage;    
    
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const langParam = urlParams.get('lang');

        if (langParam) {
            const matchingLanguage = content.languages.find(([lang, url]) => lang === langParam);
            if (matchingLanguage) {
                const [_, url] = matchingLanguage;
                window.location.href = `${url}`;
            }
        }
        

        const handleButtonClick = (event: any) => {
            if (event.target.classList.contains('cta')) {
                console.log("CTA clicked")
                trackEvent("Blog > CTA Clicked");
                window.location.href = "/login?signup=true"
            }
        };

        const parentElement = document.getElementById('blog-wrapper');
        if (parentElement) {
            document.addEventListener('click', handleButtonClick);
        }

        return () => {
            if (parentElement) {
                parentElement.removeEventListener('click', handleButtonClick);
            }
        };
    }, []);

    return (
        <Box bg="gray.0">
            <Head>
                <meta charSet="utf-8" />
                <title>{content.properties.title}</title>
                <link rel="canonical" href={`https://calensync.live${content.properties.url}`} />
                {content.languages.map(([language, url]) => (
                    <link rel="alternate" key={language} href={`https://calensync.live${url}`} hrefLang={language} />
                ))}
                <meta name="description" content={content.properties.description} />
                <meta property="og:title" content={content.properties.title} />
                <meta property="og:url" content={`https://calensync.live${content.properties.url}`} />
                <meta property="og:description" content={content.properties.description} />
                <meta property="og:publish_date" content={content.properties.publishDate} />
            </Head>
            <Container size="md" mt="md" id="blog-wrapper">
                <Paper p="md" my="md" bg="gray.0">
                    <Box mb="md" mt="md">
                        <Title order={1} mb="xs">{content.properties.title}</Title>
                        <Text fs="italic" c="dimmed">{content.properties.date}</Text>
                    </Box>

                    <Box mb="xl">
                        <MarkDown
                            rehypePlugins={[rehypeRaw]}
                            children={content.markdown}
                            components={{
                                h1(props) {
                                    const { children } = props
                                    return <Title order={1}>{children}</Title>
                                },
                                p(props) {
                                    const { children } = props
                                    return <Text size="lg" mb="md">
                                        {children}
                                    </Text>
                                },
                                strong(props) {
                                    const { children } = props
                                    return <Text span fw={700}><b>{children}</b></Text>
                                },
                                h2(props) {
                                    const { children } = props
                                    return <Title fw={400} order={2} mt="xl" pt="md" pb="md">{children}</Title>
                                },
                                h3(props) {
                                    const { children } = props
                                    return <Title fz="xl" fw={300} order={3} mt="md" pt="sm" pb="sm">{children}</Title>
                                },
                                img(props) {
                                    const { src, alt, style, width } = props
                                    return <Image
                                        mx="auto"
                                        my="sm"
                                        src={src}
                                        alt={alt}
                                        style={style}
                                        w={width}
                                        radius="md"
                                    />
                                },
                                a(props) {
                                    const { children, href } = props
                                    if (typeof children === 'string' && children.includes('CUSTOM_BUTTON')) {
                                        const content = children.replace('CUSTOM_BUTTON:', '')
                                        const onClick = () => {
                                            console.log("CTA clicked")
                                            trackEvent("Blog > CTA Clicked");
                                            redirectWithParameters('login', { signup: 'true' }, true)
                                        }
                                        return (
                                            <Group justify='center' my='md'>
                                                <Stack justify='center' my='md' gap="0">
                                                    <Button color="primary.4" size="compact-md" className="cta" onClick={onClick}>{content}</Button>
                                                    <Text size="sm" c="dimmed">.. and get 7 days free trial</Text>
                                                </Stack>
                                            </Group>
                                        )
                                    } else if (href.toLowerCase().startsWith('blog/')) {
                                        const blogId = href.toLowerCase().replace('blog/', '')
                                        const content = getBlogByLanguage(blogs[blogId], matchingLanguageCode)
                                        return <Anchor href={content.url}>{children}</Anchor>
                                    } else {
                                        return <Anchor href={href}>{children}</Anchor>
                                    }
                                }
                            }}
                        />
                    </Box>
                    {content.properties.readMore && (
                        <Stack justify='center' mb='xl'>
                            <Divider label='More from our blog' />
                            <Stack gap='xs' w='100%'>
                                {content.properties.readMore.map((blogId) => {
                                    const content = getBlogByLanguage(blogs[blogId], matchingLanguageCode)
                                    return (
                                        <Paper bd={1} bg='alpha' p='md' w='100%' key={`blog-${blogId}`}>
                                            <Anchor href={content.url}>{content.title}</Anchor>
                                            <Text size="sm" c="dimmed">{content.headline}</Text>
                                        </Paper>
                                    )
                                })}
                            </Stack>

                        </Stack>
                    )}
                </Paper>
            </Container>
        </Box>
    );
};

const BlogTemplate: React.FC = () => {
    return (
        <Layout>
            <InnerBlogTemplate />
        </Layout>
    );
};

export default BlogTemplate;